module.exports = __webpack_public_path__ + "static/media/file_success_icon.faecb334.svg";